var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header',{attrs:{"id":"header"}},[_c('div',{attrs:{"id":"navbar"}},[_c('Navbar')],1)]),_c('main',{staticStyle:{"margin-top":"50px"},attrs:{"id":"main"}},[_c('router-view')],1),_c('Sidebar'),_c('footer',[_c('FooterComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }